import { combineReducers } from 'redux';
import viewItem from './view-item/reducer';
import startPage from './start-page/reducer';
import checkout from './checkout/reducer';
import syi from './syi/reducer';
import initData from 'init-data';

let reducers = {
    checkout,
    viewItem,
    startPage
};
if (initData.pageName === 'SellItem') {
    reducers.syi = syi;
}

export default combineReducers(reducers);
